const DefaultHeader = () => {
    return (
        <nav className="shell-app-header">
            <div className="shell-app-logo">
                <h1 className="forceone-title">
                    <span className="forcepoint-title">
                        Forcepoint <span className="security-title no-pipe">Data Security Cloud</span>
                    </span>
                </h1>
            </div>
        </nav>
    )
}

export default DefaultHeader
